import { useEffect, useState } from 'react';
import { useTheme } from '@material-ui/core';
import { FEATURES } from '../../../../../common/constants/features';
import { ICheckoutTheme } from '../../../common/theme/ICheckoutTheme';
import { GetDeal_deal_car, GetDeal_deal_car_selectedFeatures } from '../graphql/queries/__generated__/GetDeal';

export const useCarOptions = (car: GetDeal_deal_car): GetDeal_deal_car_selectedFeatures[] => {
  const {
    checkoutLite: { isFromAltSpc },
  } = useTheme<ICheckoutTheme>();

  const [carOptions, setCarOptions] = useState<GetDeal_deal_car_selectedFeatures[]>([]);

  useEffect(() => {
    if (isFromAltSpc) {
      const carOptions = car.selectedFeatures?.filter(
        option => !option.code.includes(FEATURES.BACKGROUND) && !option.code.includes(FEATURES.ROOF),
      );

      setCarOptions(carOptions);
    } else {
      setCarOptions(car.selectedFeatures);
    }
  }, [car]);

  return carOptions;
};
